<template>
  <nav class="nav" v-show="!isFullScreen">
    <div class="gradient-line max-width"></div>
    <div class="nav__menu">
      <ul v-for="nav in navList" :key="nav" class="nav__menu--list">
        <li>
          <router-link :to="nav.route" @click="isActiveRoute(nav.route)">
            <span :class="{ 'nav-active': nav.active }">
              <img :src="nav.active ? nav.activeIcon : nav.icon" alt="" />
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
// nav icon
// import Wallet        from '@/assets/images/layouts/nav/wallet.svg'
import AutoBot from "@/assets/images/layouts/nav/auto_bot.svg";
import Home from "@/assets/images/layouts/nav/home.svg";
import Chart from "@/assets/images/layouts/nav/chart.svg";
import GridBot from "@/assets/images/layouts/sideBar/mainMenu/grid_bot.svg";
// import Favor         from '@/assets/images/layouts/nav/favor.svg'
// import WalletActive  from '@/assets/images/layouts/nav/wallet_active.svg'
import AutoBotActive from "@/assets/images/layouts/nav/auto_bot_active.svg";
import HomeActive from "@/assets/images/layouts/nav/home_active.svg";
import ChartActive from "@/assets/images/layouts/nav/chart_active.svg";
import GridBotActive from "@/assets/images/layouts/sideBar/mainMenu/gridActive.svg";
// import FavorActive   from '@/assets/images/layouts/nav/favor_active.svg'

// const dialogVisible = ref(false);
// const popupStore    = usePopupList();
const store = useStore();
const route = useRoute();
const isFullScreen = computed(() => store.state.useFullScreen.isFullScreen);

const navList = ref([
  // {
  //     key         : "wallet",
  //     icon        : Wallet,
  //     activeIcon  : WalletActive,
  //     route       : "/wallet",
  //     active      : false,
  //     beta        : true,
  // },
  {
    key: "auto_bot",
    icon: AutoBot,
    activeIcon: AutoBotActive,
    route: "/kibot/bot/position",
    active: false,
    beta: false,
  },
  {
    key: "gird_bot",
    icon: GridBot,
    activeIcon: GridBotActive,
    route: "/kibot/bot/grid",
    active: false,
    beta: false,
  },
  // {
  //     key         : "dash_board",
  //     icon        : Home,
  //     activeIcon  : HomeActive,
  //     route       : "/",
  //     active      : true,
  //     beta        : true,
  // },
  {
    key: "chart",
    icon: Chart,
    activeIcon: ChartActive,
    route: "/kibot/chart2",
    // route:"",
    active: false,
    beta: true,
  },
  // {
  //     key         : "favor",
  //     icon        : Favor,
  //     activeIcon  : FavorActive,
  //     route       : "",
  //     active      : false,
  //     beta        : false,
  // },
  // {
  //     key         : "brief",
  //     icon        : Chart,
  //     activeIcon  : ChartActive,
  //     route       : "/brief/detail",
  //     active      : false,
  //     beta        : true,
  // },
]);

// const betaClickHandler = (showPopup) => {
//     dialogVisible.value = showPopup;
// }

const isActiveRoute = (route) => {
  store.dispatch("usePopupList/openBetaPopup", false);
  if (route === "") {
    store.dispatch("usePopupList/openBetaPopup", true);
    // popupStore.openBetaPopup(true);
    return;
  }

  navList.value.forEach((ob) => (ob.active = false));
  // console.log('navList',navList.value,'route',route);

  // const filtered = navList.value.find(ob => ob.route === route);
  const filtered = navList.value.find((ob) => {
    if (route == "/kibot/chart") {
      route = "/kibot/chart2";
    }
    return ob.route === route;
  });

  if (filtered) {
    filtered.active = true;
  } 

};
watch(
  () => route.path,
  () => {
    isActiveRoute(route.path);
  }
);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/login/after/Nav.scss";
</style>
